import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterContentInit, Component, ContentChildren, ElementRef, QueryList } from '@angular/core';

export const speedDialFabAnimations = [
  trigger('fabToggler', [
    state(
      'inactive',
      style({
        transform: 'scale(1)'
      })
    ),
    state(
      'active',
      style({
        transform: 'scale(1.2)'
      })
    ),
    transition('* <=> *', animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
  ])
];

@Component({
  selector: 'ebw-monorepo-map-control-speed-dial',
  templateUrl: './map-control-speed-dial.component.html',
  styleUrls: ['./map-control-speed-dial.component.scss'],
  animations: speedDialFabAnimations
})
export class MapControlSpeedDialComponent implements AfterContentInit {
  @ContentChildren('MapControl', { read: ElementRef }) children: QueryList<ElementRef>;

  public fabTogglerState = 'inactive';
  public length;
  public isHidden = true;

  constructor() {
    //
  }

  ngAfterContentInit(): void {
    this.length = this.children.toArray().length;
  }

  showItems() {
    this.fabTogglerState = 'active';
    this.isHidden = false;
  }

  hideItems() {
    this.fabTogglerState = 'inactive';
    this.isHidden = true;
  }

  onToggleFab() {
    this.isHidden ? this.showItems() : this.hideItems();
  }
}
